import React from 'react';

const LoaderElement: React.FC = () => (
  <div className='loader__container'>
    <div className='loader' />
  </div>
);

export default LoaderElement;
